import service from "@/store/services/event-package-addons-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  eventPackageAddon: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, eventPackageAddon) => {
    state.eventPackageAddon = eventPackageAddon;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((eventPackageAddon) => {
      commit("SET_RESOURCE", eventPackageAddon);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((eventPackageAddon) => {
      commit("SET_RESOURCE", eventPackageAddon);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((eventPackageAddon) => {
      commit("SET_RESOURCE", eventPackageAddon);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  eventPackageAddon: (state) => state.eventPackageAddon,
  url: (state) => state.url,
};

const eventPackageAddons = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default eventPackageAddons;
